export const VERSION = "3.53.1" || 'Test version';
export const COVEO_FRAMEWORK = ['@coveo/atomic', '@coveo/quantic'];
